/**
 * Traverse the scene graph and call the callback on each node only if is visible
 */
export const traverseVisible = <TNode extends { children?: TNode[]; visible?: boolean }>(
  root: TNode,
  callback: (node: TNode) => void
): void => {
  if (root.visible === false) {
    return;
  }
  callback(root);

  const children = root.children ?? [];
  for (let i = 0, l = children.length; i < l; i++) {
    traverseVisible(children[i], callback);
  }
};
